module.exports = __webpack_public_path__ + "img/estimated-insurance-required-output.f0afeeb2.svg";